package dk.smark.demo.map

sealed interface MapEvent {
    data class MapClicked(val position: LatLon) : MapEvent
    data class MarkerClicked(val markerId: String) : MapEvent
    data class CameraMoved(val camera: MapCameraState) : MapEvent

    data object MapLoaded : MapEvent
}